module.exports = __webpack_public_path__ + "385f7c04ed7bebb0edda110e9fe41102.png";